// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     getCoupons,
//     getCompanies,
//     createCoupon,
// } from "../../../Servicefile/couponService.jsx";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';

// const Couponsdata = () => {
//     const [coupons, setCoupons] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [showPopup, setShowPopup] = useState(false);
//     const [customers, setCustomers] = useState([]);
//     const [customerSearch, setCustomerSearch] = useState("");
//     const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
//     const { showLoader, hideLoader } = useLoader();
//     const [formData, setFormData] = useState({
//         code: "",
//         discountAmount: "",
//         isActive: true,
//         customerId: "",
//         usageType: "CAMPAIGN",
//         usageLimit: "",
//     });
//     useEffect(() => {
//         fetchCustomers();
//     }, []);
//     useEffect(() => {
//         fetchCoupons();
//     }, []);
//     const fetchCustomers = async () => {
//         try {
//             showLoader();

//             const data = await getCompanies();

//             const filteredCustomers = (data || []).filter(
//                 (item) =>
//                     item.parentId === null ||
//                     item.parentId === 0 ||
//                     item.parentId === undefined
//             );

//             setCustomers(filteredCustomers);

//         } catch (error) {
//             console.error(
//                 "Fetch Customers Error:",
//                 error
//             );
//         } finally {
//             hideLoader();
//         }
//     };

//     const fetchCoupons = async () => {

//         try {
//             showLoader();
//             setLoading(true);

//             const data =
//                 await getCoupons();

//             setCoupons(data || []);

//         } catch (error) {

//             console.error(
//                 "Fetch Coupons Error:",
//                 error
//             );

//         } finally {

//             setLoading(false);
//             hideLoader();
//         }
//     };

//     const handleChange = (key, value) => {
//         setFormData((prev) => ({
//             ...prev,
//             [key]: value,
//         }));
//     };

//     const handleCreateCoupon = async () => {

//         try {
//             showLoader();

//             const payload = {
//                 code: formData.code,
//                 discountAmount: Number(
//                     formData.discountAmount
//                 ),
//                 isActive: formData.isActive,
//                 customerId:
//                     formData.customerId,
//                 usageType:
//                     formData.usageType,
//                 usageLimit: Number(
//                     formData.usageLimit
//                 ),
//             };

//             await createCoupon(payload);

//             alert(
//                 "Coupon Created Successfully"
//             );

//             setShowPopup(false);

//             setFormData({
//                 code: "",
//                 discountAmount: "",
//                 isActive: true,
//                 customerId: "",
//                 usageType: "CAMPAIGN",
//                 usageLimit: "",
//             });

//             setCustomerSearch("");

//             fetchCoupons();

//         } catch (error) {

//             console.error(
//                 "Create Coupon Error:",
//                 error
//             );

//             alert(
//                 "Failed to create coupon"
//             );
//         } finally {
//             hideLoader();
//         }
//     };

//     return (
//         <div style={containerStyle}>
//             {/* Top Section */}
//             <div style={topBarStyle}>


//                 <button
//                     style={createButtonStyle}
//                     onClick={() =>
//                         setShowPopup(true)
//                     }
//                 >
//                     Create Coupon
//                 </button>
//             </div>

//             {/* Table */}
//             <div style={tableWrapperStyle}>
//                 <table style={tableStyle}>
//                     <thead>
//                         <tr>
//                             <th style={thStyle}>
//                                 Coupon Code
//                             </th>
//                             <th style={thStyle}>
//                                 Discount Amount
//                             </th>
//                             <th style={thStyle}>
//                                 Active
//                             </th>
//                             <th style={thStyle}>
//                                 Customer Id
//                             </th>
//                             <th style={thStyle}>
//                                 Usage Type
//                             </th>
//                             <th style={thStyle}>
//                                 Usage Limit
//                             </th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {coupons.length > 0 ? (
//                             coupons.map(
//                                 (
//                                     item,
//                                     index
//                                 ) => (
//                                     <tr
//                                         key={
//                                             index
//                                         }
//                                     >
//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {
//                                                 item.code
//                                             }
//                                         </td>

//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {
//                                                 item.discountAmount
//                                             }
//                                         </td>

//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {item.isActive
//                                                 ? "Yes"
//                                                 : "No"}
//                                         </td>

//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {
//                                                 item.customerId
//                                             }
//                                         </td>

//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {
//                                                 item.usageType
//                                             }
//                                         </td>

//                                         <td
//                                             style={
//                                                 tdStyle
//                                             }
//                                         >
//                                             {
//                                                 item.usageLimit
//                                             }
//                                         </td>
//                                     </tr>
//                                 )
//                             )
//                         ) : (
//                             <tr>
//                                 <td
//                                     colSpan="6"
//                                     style={{
//                                         textAlign:
//                                             "center",
//                                         padding:
//                                             "20px",
//                                     }}
//                                 >
//                                     {loading
//                                         ? "Loading..."
//                                         : "No Coupons Found"}
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Popup */}
//             {showPopup && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         inset: 0,
//                         background: "rgba(15, 23, 42, 0.55)",
//                         backdropFilter: "blur(4px)",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         zIndex: 9999,
//                         padding: "20px",
//                     }}
//                 >
//                     <div
//                         style={{
//                             width: "100%",
//                             maxWidth: "760px",
//                             background: "#ffffff",
//                             borderRadius: "24px",
//                             padding: "20px",
//                             boxShadow:
//                                 "0 20px 45px rgba(0,0,0,0.18)",
//                             border: "1px solid #e5e7eb",
//                             animation: "popupFade 0.3s ease",
//                         }}
//                     >
//                         {/* HEADER */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 // marginBottom: "15px",
//                             }}
//                         >
//                             <div>
//                                 <h2
//                                     style={{
//                                         margin: 0,
//                                         fontSize: "26px",
//                                         fontWeight: "700",
//                                         color: "#111827",
//                                     }}
//                                 >
//                                     Create Coupon
//                                 </h2>

//                                 <p
//                                     style={{
//                                         marginTop: "6px",
//                                         fontSize: "14px",
//                                         color: "#6b7280",
//                                     }}
//                                 >
//                                     Create and manage coupon discounts
//                                 </p>
//                             </div>

//                             <button
//                                 onClick={() =>
//                                     setShowPopup(false)
//                                 }
//                                 style={{
//                                     width: "38px",
//                                     height: "38px",
//                                     borderRadius: "50%",
//                                     border: "none",
//                                     background: "#f3f4f6",
//                                     cursor: "pointer",
//                                     fontSize: "18px",
//                                     fontWeight: "bold",
//                                     color: "#374151",
//                                 }}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         {/* FORM GRID */}
//                         <div
//                             style={{
//                                 display: "grid",
//                                 gridTemplateColumns:
//                                     "repeat(auto-fit, minmax(240px, 1fr))",
//                                 gap: "14px",
//                             }}
//                         >
//                             {/* Coupon Code */}
//                             <div>
//                                 <label
//                                     style={{
//                                         display: "block",
//                                         marginBottom: "5px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         color: "#374151",
//                                     }}
//                                 >
//                                     Coupon Code
//                                 </label>

//                                 <input
//                                     type="text"
//                                     value={formData.code}
//                                     onChange={(e) =>
//                                         handleChange(
//                                             "code",
//                                             e.target.value
//                                         )
//                                     }
//                                     placeholder="Enter coupon code"
//                                     style={{
//                                         width: "100%",
//                                         height: "48px",
//                                         borderRadius: "14px",
//                                         border:
//                                             "1.5px solid #d1d5db",
//                                         padding: "0 14px",
//                                         fontSize: "14px",
//                                         outline: "none",
//                                         transition: "0.2s",
//                                         boxSizing: "border-box",
//                                     }}
//                                 />
//                             </div>

//                             {/* Discount */}
//                             <div>
//                                 <label
//                                     style={{
//                                         display: "block",
//                                         marginBottom: "5px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         color: "#374151",
//                                     }}
//                                 >
//                                     Discount Amount
//                                 </label>

//                                 <input
//                                     type="number"
//                                     value={
//                                         formData.discountAmount
//                                     }
//                                     onChange={(e) =>
//                                         handleChange(
//                                             "discountAmount",
//                                             e.target.value
//                                         )
//                                     }
//                                     placeholder="Enter amount"
//                                     style={{
//                                         width: "100%",
//                                         height: "48px",
//                                         borderRadius: "14px",
//                                         border:
//                                             "1.5px solid #d1d5db",
//                                         padding: "0 14px",
//                                         fontSize: "14px",
//                                         outline: "none",
//                                         boxSizing: "border-box",
//                                     }}
//                                 />
//                             </div>

//                             {/* Customer ID */}
//                             {/* Select Company */}
//                             <div style={{ position: "relative" }}>

//                                 <label
//                                     style={{
//                                         display: "block",
//                                         marginBottom: "5px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         color: "#374151",
//                                     }}
//                                 >
//                                     Select Company
//                                 </label>

//                                 <input
//                                     type="text"
//                                     value={customerSearch}
//                                     onFocus={() =>
//                                         setShowCompanyDropdown(true)
//                                     }
//                                     onChange={(e) => {

//                                         setCustomerSearch(
//                                             e.target.value
//                                         );

//                                         // ✅ Open dropdown while typing
//                                         setShowCompanyDropdown(true);

//                                         // ✅ Clear customerId if input cleared
//                                         if (e.target.value === "") {
//                                             handleChange(
//                                                 "customerId",
//                                                 ""
//                                             );
//                                         }
//                                     }}
//                                     placeholder="Search company name"
//                                     style={{
//                                         width: "100%",
//                                         height: "48px",
//                                         borderRadius: "14px",
//                                         border: "1.5px solid #d1d5db",
//                                         padding: "0 14px",
//                                         fontSize: "14px",
//                                         outline: "none",
//                                         boxSizing: "border-box",
//                                         background: "#fff",
//                                     }}
//                                 />

//                                 {/* DROPDOWN */}
//                                 {showCompanyDropdown && (
//                                     <div
//                                         style={{
//                                             position: "absolute",
//                                             top: "75px",
//                                             left: 0,
//                                             right: 0,
//                                             background: "#fff",
//                                             border: "1px solid #e5e7eb",
//                                             borderRadius: "12px",
//                                             maxHeight: "220px",
//                                             overflowY: "auto",
//                                             zIndex: 999,
//                                             boxShadow:
//                                                 "0 10px 25px rgba(0,0,0,0.12)",
//                                         }}
//                                     >

//                                         {customers
//                                             .filter((item) => {

//                                                 // ✅ Show all initially
//                                                 if (!customerSearch)
//                                                     return true;

//                                                 // ✅ Filter while typing
//                                                 return item.companyName
//                                                     ?.toLowerCase()
//                                                     .includes(
//                                                         customerSearch.toLowerCase()
//                                                     );
//                                             })
//                                             .map((item) => (

//                                                 <div
//                                                     key={item.vendorId}
//                                                     onClick={() => {

//                                                         // ✅ Show selected company in input
//                                                         setCustomerSearch(
//                                                             item.companyName
//                                                         );

//                                                         // ✅ Send referenceId as customerId
//                                                         handleChange(
//                                                             "customerId",
//                                                             item.referenceId
//                                                         );

//                                                         // ✅ Close dropdown
//                                                         setShowCompanyDropdown(false);
//                                                     }}
//                                                     style={{
//                                                         padding: "12px 14px",
//                                                         cursor: "pointer",
//                                                         borderBottom:
//                                                             "1px solid #f3f4f6",
//                                                         transition: "0.2s",
//                                                     }}
//                                                     onMouseEnter={(e) => {
//                                                         e.currentTarget.style.background =
//                                                             "#f9fafb";
//                                                     }}
//                                                     onMouseLeave={(e) => {
//                                                         e.currentTarget.style.background =
//                                                             "#fff";
//                                                     }}
//                                                 >

//                                                     <div
//                                                         style={{
//                                                             fontSize: "14px",
//                                                             fontWeight: 600,
//                                                             color: "#111827",
//                                                         }}
//                                                     >
//                                                         {item.companyName}
//                                                     </div>

//                                                     <div
//                                                         style={{
//                                                             fontSize: "12px",
//                                                             color: "#6b7280",
//                                                             marginTop: "2px",
//                                                         }}
//                                                     >
//                                                         {item.referenceId}
//                                                     </div>

//                                                 </div>
//                                             ))}

//                                         {/* No Data */}
//                                         {customers.filter((item) =>
//                                             item.companyName
//                                                 ?.toLowerCase()
//                                                 .includes(
//                                                     customerSearch.toLowerCase()
//                                                 )
//                                         ).length === 0 && (
//                                                 <div
//                                                     style={{
//                                                         padding: "14px",
//                                                         textAlign: "center",
//                                                         color: "#6b7280",
//                                                         fontSize: "13px",
//                                                     }}
//                                                 >
//                                                     No company found
//                                                 </div>
//                                             )}

//                                     </div>
//                                 )}
//                             </div>
//                             {/* Usage Type */}
//                             <div>
//                                 <label
//                                     style={{
//                                         display: "block",
//                                         marginBottom: "5px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         color: "#374151",
//                                     }}
//                                 >
//                                     Usage Type
//                                 </label>

//                                 <select
//                                     value={formData.usageType}
//                                     onChange={(e) =>
//                                         handleChange(
//                                             "usageType",
//                                             e.target.value
//                                         )
//                                     }
//                                     style={{
//                                         width: "100%",
//                                         height: "48px",
//                                         borderRadius: "14px",
//                                         border:
//                                             "1.5px solid #d1d5db",
//                                         padding: "0 14px",
//                                         fontSize: "14px",
//                                         outline: "none",
//                                         background: "#fff",
//                                         boxSizing: "border-box",
//                                     }}
//                                 >
//                                     <option value="CAMPAIGN">
//                                         CAMPAIGN
//                                     </option>

//                                     <option value="SUBSCRIPTION">
//                                         SUBSCRIPTION
//                                     </option>
//                                 </select>
//                             </div>

//                             {/* Usage Limit */}
//                             <div>
//                                 <label
//                                     style={{
//                                         display: "block",
//                                         marginBottom: "5px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         color: "#374151",
//                                     }}
//                                 >
//                                     Usage Limit
//                                 </label>

//                                 <input
//                                     type="number"
//                                     value={formData.usageLimit}
//                                     onChange={(e) =>
//                                         handleChange(
//                                             "usageLimit",
//                                             e.target.value
//                                         )
//                                     }
//                                     placeholder="Enter limit"
//                                     style={{
//                                         width: "100%",
//                                         height: "48px",
//                                         borderRadius: "14px",
//                                         border:
//                                             "1.5px solid #d1d5db",
//                                         padding: "0 14px",
//                                         fontSize: "14px",
//                                         outline: "none",
//                                         boxSizing: "border-box",
//                                     }}
//                                 />
//                             </div>
//                         </div>

//                         {/* BUTTONS */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 gap: "14px",
//                                 marginTop: "20px",
//                             }}
//                         >
//                             <button
//                                 onClick={() =>
//                                     setShowPopup(false)
//                                 }
//                                 style={{
//                                     height: "46px",
//                                     padding: "0 24px",
//                                     borderRadius: "14px",
//                                     border:
//                                         "1px solid #d1d5db",
//                                     background: "#f9fafb",
//                                     color: "#374151",
//                                     fontWeight: 600,
//                                     cursor: "pointer",
//                                     fontSize: "14px",
//                                 }}
//                             >
//                                 Cancel
//                             </button>

//                             <button
//                                 onClick={
//                                     handleCreateCoupon
//                                 }
//                                 style={{
//                                     height: "46px",
//                                     padding: "0 28px",
//                                     borderRadius: "14px",
//                                     border: "none",
//                                     background:
//                                         "linear-gradient(135deg,#f97316,#ea580c)",
//                                     color: "#fff",
//                                     fontWeight: 700,
//                                     cursor: "pointer",
//                                     fontSize: "14px",
//                                     boxShadow:
//                                         "0 10px 20px rgba(249,115,22,0.25)",
//                                 }}
//                             >
//                                 Save Coupon
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// const containerStyle = {
//     padding: "20px",
//     fontFamily:
//         "Segoe UI, sans-serif",
// };

// const topBarStyle = {
//     display: "flex",
//     justifyContent:
//         "space-between",
//     alignItems: "center",
//     marginBottom: "20px",
// };

// const createButtonStyle = {
//     background:
//         "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     padding: "10px 18px",
//     borderRadius: "8px",
//     cursor: "pointer",
//     fontSize: "15px",
//     fontWeight: "600",
// };

// const tableWrapperStyle = {
//     overflowX: "auto",
//     border: "1px solid #ddd",
//     borderRadius: "10px",
// };

// const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
// };

// const thStyle = {
//     background:
//         "rgb(230 109 51)",
//     color: "#fff",
//     padding: "14px",
//     textAlign: "center",
//     fontWeight: "600",
// };

// const tdStyle = {
//     padding: "14px",
//     textAlign: "center",
//     borderBottom:
//         "1px solid #ddd",
// };

// const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background:
//         "rgba(0,0,0,0.4)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 999,
// };

// const popupStyle = {
//     background: "#fff",
//     width: "700px",
//     borderRadius: "12px",
//     padding: "25px",
// };

// const formGridStyle = {
//     display: "grid",
//     gridTemplateColumns:
//         "repeat(2,1fr)",
//     gap: "18px",
// };

// const labelStyle = {
//     display: "block",
//     marginBottom: "5px",
//     fontWeight: "600",
//     fontSize: "14px",
// };

// const inputStyle = {
//     width: "100%",
//     padding: "12px",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     outline: "none",
// };

// const saveButtonStyle = {
//     background:
//         "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     padding: "10px 20px",
//     borderRadius: "8px",
//     cursor: "pointer",
// };

// const cancelButtonStyle = {
//     background: "#6b7280",
//     color: "#fff",
//     border: "none",
//     padding: "10px 20px",
//     borderRadius: "8px",
//     cursor: "pointer",
// };

// export default Couponsdata;




import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    getCoupons,
    getCompanies,
    createCoupon,
} from "../../../Servicefile/couponService.jsx";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Add: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Coupon: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    ),
    Discount: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Active: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#276749" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Inactive: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9b2c2c" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Company: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        // padding: '20px 16px',
        // background: '#f8f9fa',
        // borderRadius: '16px',
        // boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginBottom: '16px',
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #edf2f7'
    },
    statItem: {
        textAlign: 'center'
    },
    statValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    statLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        scrollbarWidth:'none',
        maxHeight: '60vh',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '700px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '12px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    badgeInactive: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    button: {
        padding: '10px 20px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    modal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '580px',
        maxWidth: '95%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    modalBody: {
        padding: '0 0 4px 0'
    },
    formGroup: {
        marginBottom: '16px'
    },
    label: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    input: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white'
    },
    select: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white',
        cursor: 'pointer'
    },
    modalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px'
    },
    formRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px'
    },
    dropdown: {
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        right: 0,
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        maxHeight: '220px',
        overflowY: 'auto',
        zIndex: 1000,
        boxShadow: '0 10px 25px rgba(0,0,0,0.12)'
    },
    dropdownItem: {
        padding: '10px 14px',
        cursor: 'pointer',
        borderBottom: '1px solid #f3f4f6',
        transition: 'all 0.2s ease'
    },
    dropdownItemHover: {
        background: '#f9fafb'
    },
    dropdownItemName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#111827'
    },
    dropdownItemId: {
        fontSize: '12px',
        color: '#6b7280',
        marginTop: '2px'
    },
    couponCode: {
        fontWeight: '600',
        color: 'rgb(230 109 51)',
        fontFamily: 'monospace',
        fontSize: '13px'
    },
    discountAmount: {
        fontWeight: '700', 
        color: '#0b5e42',
        fontSize: '15px'
    }
};

const Couponsdata = () => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [customerSearch, setCustomerSearch] = useState("");
    const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const [formData, setFormData] = useState({
        code: "",
        discountAmount: "",
        isActive: true,
        customerId: "",
        usageType: "CAMPAIGN",
        usageLimit: "",
    });

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        fetchCustomers();
        fetchCoupons();
    }, []);

    const fetchCustomers = async () => {
        try {
            showLoader();
            const data = await getCompanies();
            const filteredCustomers = (data || []).filter(
                (item) => item.parentId === null || item.parentId === 0 || item.parentId === undefined
            );
            setCustomers(filteredCustomers);
        } catch (error) {
            console.error("Fetch Customers Error:", error);
        } finally {
            hideLoader();
        }
    };

    const fetchCoupons = async () => {
        try {
            showLoader();
            setLoading(true);
            const data = await getCoupons();
            setCoupons(data || []);
        } catch (error) {
            console.error("Fetch Coupons Error:", error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const handleChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleCreateCoupon = async () => {
        try {
            showLoader();
            const payload = {
                code: formData.code,
                discountAmount: Number(formData.discountAmount),
                isActive: formData.isActive,
                customerId: formData.customerId,
                usageType: formData.usageType,
                usageLimit: Number(formData.usageLimit),
            };
            await createCoupon(payload);
            alert("✅ Coupon Created Successfully");
            setShowPopup(false);
            setFormData({
                code: "",
                discountAmount: "",
                isActive: true,
                customerId: "",
                usageType: "CAMPAIGN",
                usageLimit: "",
            });
            setCustomerSearch("");
            fetchCoupons();
        } catch (error) {
            console.error("Create Coupon Error:", error);
            alert("❌ Failed to create coupon");
        } finally {
            hideLoader();
        }
    };

    // Calculate stats
    const totalCoupons = coupons.length;
    const activeCount = coupons.filter(c => c.isActive).length;
    const inactiveCount = coupons.filter(c => !c.isActive).length;
    const campaignCount = coupons.filter(c => c.usageType === "CAMPAIGN").length;

    return (
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <div style={styles.title}>
                    <Icons.Coupon /> Coupon Management
                    <span style={styles.titleBadge}>{totalCoupons}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <button
                        onClick={fetchCoupons}
                        style={{ ...styles.button, ...styles.buttonSecondary }}
                    >
                        <Icons.Refresh /> Refresh
                    </button>
                    <button
                        onClick={() => setShowPopup(true)}
                        style={{ ...styles.button, ...styles.buttonPrimary }}
                    >
                        <Icons.Add /> Create Coupon
                    </button>
                </div>
            </div>

           
            

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '5%' }}>#</th>
                            <th style={{ ...styles.th, width: '20%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    Coupon Code
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '15%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Discount /> Discount
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '10%', textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    Status
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '15%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Company /> Customer
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '15%' }}>Usage Type</th>
                            <th style={{ ...styles.th, width: '10%' }}>Usage Limit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7" style={{ padding: 0 }}>
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading coupons...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : coupons.length > 0 ? (
                            coupons.map((item, index) => (
                                <tr
                                    key={item.id || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                    <td style={{ ...styles.td, ...styles.couponCode }}>{item.code}</td>
                                    <td style={{ ...styles.td, ...styles.discountAmount }}>₹{item.discountAmount}</td>
                                    <td style={styles.td}>
                                        <span style={{
                                            ...styles.badge,
                                            ...(item.isActive ? styles.badgeActive : styles.badgeInactive)
                                        }}>
                                            {item.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, fontSize: '12px' }}>{item.customerId || 'N/A'}</td>
                                    <td style={styles.td}>
                                        <span style={{
                                            background: item.usageType === 'CAMPAIGN' ? '#bee3f8' : '#c6f6d5',
                                            padding: '2px 10px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            color: item.usageType === 'CAMPAIGN' ? '#2a4365' : '#276749'
                                        }}>
                                            {item.usageType}
                                        </span>
                                    </td>
                                    <td style={styles.td}>{item.usageLimit || 'Unlimited'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No coupons found</div>
                                        <div style={styles.emptyStateSubtext}>
                                            Create your first coupon to offer discounts to your customers
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Create Coupon Modal */}
            {showPopup && (
                <div style={styles.modalOverlay} onClick={() => setShowPopup(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                <Icons.Add style={{ color: '#e66d33' }} /> Create Coupon
                            </h3>
                            <button style={styles.modalClose} onClick={() => setShowPopup(false)}>
                                <Icons.Close />
                            </button>
                        </div>

                        <div style={styles.modalBody}>
                            <div style={styles.formRow}>
                                {/* Coupon Code */}
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Coupon Code *</label>
                                    <input
                                        type="text"
                                        value={formData.code}
                                        onChange={(e) => handleChange("code", e.target.value)}
                                        placeholder="e.g. SAVE20"
                                        style={styles.input}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#e66d33';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e2e8f0';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* Discount Amount */}
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Discount Amount *</label>
                                    <input
                                        type="number"
                                        value={formData.discountAmount}
                                        onChange={(e) => handleChange("discountAmount", e.target.value)}
                                        placeholder="Enter amount"
                                        style={styles.input}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#e66d33';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e2e8f0';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={styles.formRow}>
                                {/* Customer/Company Selection */}
                                <div style={{ ...styles.formGroup, position: 'relative' }}>
                                    <label style={styles.label}>Select Company</label>
                                    <input
                                        type="text"
                                        value={customerSearch}
                                        onFocus={() => setShowCompanyDropdown(true)}
                                        onChange={(e) => {
                                            setCustomerSearch(e.target.value);
                                            setShowCompanyDropdown(true);
                                            if (e.target.value === "") {
                                                handleChange("customerId", "");
                                            }
                                        }}
                                        placeholder="Search company name..."
                                        style={styles.input}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#e66d33';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            setTimeout(() => setShowCompanyDropdown(false), 200);
                                            e.target.style.borderColor = '#e2e8f0';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />

                                    {showCompanyDropdown && (
                                        <div style={styles.dropdown}>
                                            {customers
                                                .filter((item) => 
                                                    !customerSearch || 
                                                    item.companyName?.toLowerCase().includes(customerSearch.toLowerCase())
                                                )
                                                .map((item) => (
                                                    <div
                                                        key={item.vendorId}
                                                        onClick={() => {
                                                            setCustomerSearch(item.companyName);
                                                            handleChange("customerId", item.referenceId);
                                                            setShowCompanyDropdown(false);
                                                        }}
                                                        style={styles.dropdownItem}
                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                                    >
                                                        <div style={styles.dropdownItemName}>
                                                            {item.companyName}
                                                        </div>
                                                        <div style={styles.dropdownItemId}>
                                                            ID: {item.referenceId}
                                                        </div>
                                                    </div>
                                                ))}
                                            {customers.filter((item) => 
                                                !customerSearch || 
                                                item.companyName?.toLowerCase().includes(customerSearch.toLowerCase())
                                            ).length === 0 && (
                                                <div style={{ padding: '14px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
                                                    No companies found
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Usage Type */}
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Usage Type *</label>
                                    <select
                                        value={formData.usageType}
                                        onChange={(e) => handleChange("usageType", e.target.value)}
                                        style={styles.select}
                                    >
                                        <option value="CAMPAIGN">CAMPAIGN</option>
                                        <option value="SUBSCRIPTION">SUBSCRIPTION</option>
                                    </select>
                                </div>
                            </div>

                            <div style={styles.formRow}>
                                {/* Usage Limit */}
                                <div style={styles.formGroup}>
                                    <label style={styles.label}>Usage Limit</label>
                                    <input
                                        type="number"
                                        value={formData.usageLimit}
                                        onChange={(e) => handleChange("usageLimit", e.target.value)}
                                        placeholder="Enter limit (empty = unlimited)"
                                        style={styles.input}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#e66d33';
                                            e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e2e8f0';
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>

                                {/* Active Status */}
                                <div style={{ ...styles.formGroup, display: 'flex', alignItems: 'center', gap: '12px', paddingTop: '28px' }}>
                                    <label style={{ ...styles.label, marginBottom: 0, cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={formData.isActive}
                                            onChange={(e) => handleChange("isActive", e.target.checked)}
                                            style={{
                                                width: '18px',
                                                height: '18px',
                                                marginRight: '8px',
                                                cursor: 'pointer',
                                                accentColor: '#e66d33'
                                            }}
                                        />
                                        Active
                                    </label>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div style={styles.modalFooter}>
                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{ ...styles.button, ...styles.buttonSecondary, flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleCreateCoupon}
                                    style={{ ...styles.button, ...styles.buttonPrimary, flex: 1 }}
                                >
                                    Save Coupon
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @media (max-width: 768px) {
                    .stats-container {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .form-row {
                        grid-template-columns: 1fr !important;
                    }
                    .modal {
                        padding: 20px !important;
                        width: 98% !important;
                    }
                    .table-container table {
                        font-size: 12px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 8px 10px !important;
                        font-size: 11px !important;
                    }
                }

                @media (max-width: 480px) {
                    .stats-container {
                        grid-template-columns: 1fr !important;
                    }
                    .stat-value {
                        font-size: 18px !important;
                    }
                    .table-container table {
                        font-size: 10px !important;
                        min-width: 600px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                    .button {
                        font-size: 12px !important;
                        padding: 6px 12px !important;
                        height: 34px !important;
                    }
                    .modal {
                        padding: 16px !important;
                    }
                    .modal-title {
                        font-size: 16px !important;
                    }
                    .input, .select {
                        padding: 6px 10px !important;
                        font-size: 12px !important;
                        height: 38px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Couponsdata;